const Mailgun = () =>{
	const baseURL = 'https://sq-api.herokuapp.com/'
	const options = {
		method: 'POST',
		
	}

	const send = ({ message, number, email, name }) => {
		let params = new FormData()
	    params.append('message', message)
	    params.append('number', number)
	    params.append('email', email)
	    params.append('name', name)

	    options.body = params

		return fetch(baseURL + 'Mail', options)
	}

	return {
		send
	}
}

export default Mailgun


// WEBPACK FOOTER //
// ./src/services/Api.js